import { PageLocatorMap } from '../types/PageLocatorMap';

export const previewPinVerifyPage = {
  alert: {
    error: 'preview-pin-verify-page.alert.error',
    success: 'preview-pin-verify-page.alert.success',
  },
  footer: {
    root: 'preview-pin-verify-page.footer.root',
  },
  form: {
    h1: 'preview-pin-verify-page.form.heading1',
    h3: 'preview-pin-verify-page.form.heading3',
    pinInput1: 'preview-pin-verify-page.form.pin-input-1',
    pinInput2: 'preview-pin-verify-page.form.pin-input-2',
    pinInput3: 'preview-pin-verify-page.form.pin-input-3',
    pinInput4: 'preview-pin-verify-page.form.pin-input-4',
    pinInput5: 'preview-pin-verify-page.form.pin-input-5',
    pinInput6: 'preview-pin-verify-page.form.pin-input-6',
    pinInputError: 'preview-pin-verify-page.form.pin-error',
    resendPinLink: 'preview-pin-verify-page.form.resend-pin-link',
    root: 'preview-pin-verify-page.form.root',
  },
} as const satisfies PageLocatorMap;
